import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LazyImage } from '@treatwell/ui';
import { getImageDimensionsFromUri } from 'js/helpers/getImageDimensionsFromUri';
import styles from './Block.module.css';

export default class InfoBlock extends Component {
  static propTypes = {
    imageUri: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    uri: PropTypes.string,
    ctaText: PropTypes.string,
  };

  render() {
    const { imageUri, title, description, uri, ctaText } = this.props;
    const imageDimensions = imageUri
      ? getImageDimensionsFromUri(imageUri)
      : undefined;

    return (
      <div className={styles.block}>
        <a className={styles.link} href={uri}>
          {imageUri ? (
            <LazyImage
              className={styles.image}
              src={imageUri}
              width={imageDimensions.width}
              height={imageDimensions.height}
              style={{
                width: '100%',
                height: 'auto',
                aspectRatio: `auto ${imageDimensions.width} / ${imageDimensions.height}`,
              }}
            />
          ) : null}
          <h3 className={styles.title}>{title}</h3>
          <div className={styles.description}>{description}</div>
          {ctaText ? <span className={styles.cta}>{ctaText}</span> : null}
        </a>
      </div>
    );
  }
}
